export default "__VITE_ASSET__b14pNnrb__"